
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import Locations from '@/active-components/master-data/Locations.vue';
import Responsibles from '@/active-components/master-data/ResponsiblePage.vue';
import Topics from '@/active-components/master-data/Topics.vue';

import EventHeader from '@/components/event/EventHeader.vue';

import { mapActions, mapGetters, mapMutations } from 'vuex';
import EventLoaderMixin from '@/mixins/EventLoaderMixin';

@Component({
    components: {
        Locations,
        Topics,
        Responsibles,
        EventHeader,
    },
    computed: {
        ...mapGetters({
            getEvent: 'eventStorage/getEvent',
        }),
    },
    methods: {
        ...mapActions({
            fetchEventById: 'eventStorage/fetchEventById',
        }),
        ...mapMutations({
            setEvent: 'eventStorage/setEvent',
        }),
    },
})
export default class LocationsView extends mixins(EventLoaderMixin) {}
